module.exports = __webpack_public_path__ + "img/img2.18801a25.jpg";